/**
 *
 * @param {IdleRequestOptions?} options
 * @returns
 */
export default async function requestIdleCallback(options) {
    return new Promise(resolve => window.requestIdleCallback(resolve, options));
}
